import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import ManageSpecialties from '../components/settings/ManageSpecialties';
import ManageClinics from '../components/settings/ManageClinics';
import ManageProfessionals from '../components/settings/ManageProfessionals';
import ProfessionalScheduleManager from '../components/settings/ProfessionalScheduleManager';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agenda-tabpanel-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const AgendaConfig = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Creación de Agendas
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Configura clínicas, especialidades, profesionales y sus agendas de atención
      </Typography>

      <Paper sx={{ mt: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Clínicas" />
          <Tab label="Especialidades" />
          <Tab label="Profesionales" />
          <Tab label="Agenda de Profesionales" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <ManageClinics />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ManageSpecialties />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ManageProfessionals />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <ProfessionalScheduleManager />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default AgendaConfig;
